// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ensx","fullView":"styles_fullView__3Nib2"};